import React, { useEffect, Fragment, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import './layout.css'
// import HandyBankLogo from '../../assets/logo/IZB-LOGO-SMALL.svg'
import { Col, Container, Row } from 'react-bootstrap'
import Header from './header/header'
import { authTokenSelector } from '../../store/selectors/auth.selector'


export default function Layout({ children }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const [showSideNav, setShowSideNav] = useState(false)
  const authToken = useSelector(authTokenSelector)

      useEffect(() => {
      if (authToken === null) {
        history.push('/login')

      }
    }, [authToken])

  return (
    <Fragment>
      <Header />
      <Container id='Layout'>
        <Row className='layout-render-section'>
          <Col> {children}</Col>
        </Row>
      </Container>
    </Fragment>
  )
}
